require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-diastasis-recti.json") })
        }
      }, "path---blog-diastasis-recti");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-diastasis-recti!./.cache/json/blog-diastasis-recti.json
// module id = 285
// module chunks = 231608221292675